import React, { useState } from 'react';
import { Container, Row, Col, Card, Button, Spinner } from 'react-bootstrap';
import { Helmet } from 'react-helmet-async';
import ImageLoader from '../components/PhotoGallery/ImageLoader';
import SimpleCarousel from '../components/PhotoGallery/SimpleCarousel';

// TODO: Add lightbox functionality for grid view
// TODO: Consider adding image categories/filtering

const GalleryPage = () => {
  const [images, setImages] = useState([]);
  const [viewMode, setViewMode] = useState('carousel'); // 'carousel' or 'grid'
  const [loading, setLoading] = useState(true);

  const handleImagesLoaded = (loadedImages) => {
    console.log('[GalleryPage] Images loaded:', loadedImages.length);
    setImages(loadedImages);
    setLoading(false);
  };

  const toggleViewMode = () => {
    const newMode = viewMode === 'carousel' ? 'grid' : 'carousel';
    console.log('[GalleryPage] Switching view mode to:', newMode);
    setViewMode(newMode);
  };

  return (
    <>
      <Helmet>
        <title>Project Gallery | DD Construction - Our Work</title>
        <meta name="description" content="Browse DD Construction's portfolio of completed residential projects, home renovations, and building work across South Africa." />
        <meta property="og:title" content="Project Gallery | DD Construction - Our Work" />
        <meta property="og:description" content="Browse DD Construction's portfolio of completed residential projects and renovations." />
        <meta property="og:url" content="https://www.ddconstruction.co.za/gallery" />
        <link rel="canonical" href="https://www.ddconstruction.co.za/gallery" />
      </Helmet>

      {/* Page Header */}
      <section className="hero-section">
        <Container>
          <Row className="justify-content-center text-center">
            <Col md={8}>
              <h1>Our Project Gallery</h1>
              <p className="lead">
                Browse through our portfolio of completed construction projects.
                From residential homes to renovations, our work showcases our
                commitment to quality and craftsmanship.
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      <Container className="py-5">
        {/* Hidden Image Loader Component */}
        <div style={{ display: 'none' }}>
          <ImageLoader onImagesLoaded={handleImagesLoaded} />
        </div>

        {loading ? (
          <div className="text-center py-5">
            <Spinner animation="border" role="status" variant="primary">
              <span className="visually-hidden">Loading images...</span>
            </Spinner>
            <p className="mt-3 text-muted">Loading gallery images...</p>
          </div>
        ) : (
          <>
            {/* View Mode Toggle */}
            <div className="d-flex justify-content-end mb-4">
              <Button
                variant="outline-primary"
                onClick={toggleViewMode}
                className="d-flex align-items-center"
              >
                <i
                  className={`bi bi-${viewMode === 'carousel' ? 'grid-3x3-gap' : 'images'} me-2`}
                ></i>
                {viewMode === 'carousel' ? 'Grid View' : 'Slideshow View'}
              </Button>
            </div>

            {/* Gallery Content */}
            {images.length > 0 ? (
              viewMode === 'carousel' ? (
                <SimpleCarousel images={images} />
              ) : (
                <Row className="g-4">
                  {images.map((image, index) => (
                    <Col sm={6} md={4} lg={3} key={image.key || index}>
                      <Card className="project-card h-100 border-0">
                        <div className="overflow-hidden rounded">
                          <Card.Img
                            variant="top"
                            src={image.url}
                            alt={image.name || image.description || `DD Construction residential project ${index + 1}`}
                          />
                        </div>
                      </Card>
                    </Col>
                  ))}
                </Row>
              )
            ) : (
              <div className="text-center py-5">
                <i
                  className="bi bi-images text-muted"
                  style={{ fontSize: '3rem' }}
                ></i>
                <p className="mt-3 text-muted">No images to display.</p>
              </div>
            )}
          </>
        )}
      </Container>
    </>
  );
};

export default GalleryPage;
